import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import { MCButton, TextField, ToggleSwitch } from 'src/components/basic';
import { lang, withRouter, remCss } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';
import config from 'src/config';

import model from 'src/model';

class AppSettings extends BaseComponent {
  state = {
    changed: false,
    settings: {}
  };

  componentDidMount() {
    model.subscribe(this.subscription);
    this.loadSettings();
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  loadSettings = () => {
    let confSettings = config.get('appSettings') || {};
    const settings = model.getState().appSettings || config.get('appSettings') || {};
    this.setState({ settings: { ...confSettings, ...settings }, changed: false });
  };

  handleChange = (key) => (name, value) => {
    this.setState({
      settings: {
        ...this.state.settings,
        [key]: value
      },
      changed: true
    });
  };

  handleToggle = (key) => () => {
    this.setState({
      settings: {
        ...this.state.settings,
        [key]: !this.state.settings[key]
      },
      changed: true
    });
  };

  saveSettings = (e) => {
    e.preventDefault();
    model.setState({ appSettings: this.state.settings });
    config.set('appSettings', this.state.settings);
    this.setState({ changed: false });
  };

  cancelChanges = () => {
    this.loadSettings();
  };

  render() {
    const { settings, changed } = this.state;

    return (
      <div className={'mc-main-content mc-flex-col'}>
        <form className={'mc-setting-consultation mc-grow'} onSubmit={this.saveSettings}>
          <div className={'mc-header'}>
            <div className={'mc-title'}>{lang.t('App Settings')}</div>
          </div>

          <div className={'mc-p30 mc-grow mc-flex-30-col'} style={{ overflow: 'auto' }}>
            <div className={'mc-flex-20-col'} style={{ maxWidth: remCss(400) }}>
              <div
                className={'mc-flex-20'}
                style={{ padding: remCss(10), paddingRight: remCss(30) }}
              >
                <div className={'mc-value-518 mc-grow'}>{lang.t('Enable TUS Upload')}</div>
                <ToggleSwitch
                  name='tus'
                  checked={!!settings.tus}
                  onChange={this.handleToggle('tus')}
                />
              </div>

              {!!settings.tus && (
                <div className={'mc-flex-20'}>
                  <div className={'mc-grow'}>
                    <TextField
                      template={3}
                      type='number'
                      label={lang.t('Chunk Size (MB)')}
                      name='chunkSize'
                      value={(settings.chunkSize ?? 10485760) / (1024 * 1024)}
                      onChange={(key, value) =>
                        this.handleChange('chunkSize')(key, value * 1024 * 1024)
                      }
                      placeholder='10'
                      inputProps={{
                        type: 'number'
                        // min: 1
                        // style: {
                        //   width: remCss(150)
                        // }
                      }}
                    />
                  </div>
                </div>
              )}

              {!!settings.tus && (
                <div className={'mc-flex-20'}>
                  <div className={'mc-grow'}>
                    <TextField
                      template={3}
                      type='number'
                      label={lang.t('Parallel Upload Chunks')}
                      name='parallelUploads'
                      value={settings.parallelUploads || 1}
                      onChange={this.handleChange('parallelUploads')}
                      placeholder='1'
                      inputProps={{
                        type: 'number',
                        min: 1,
                        max: 1000
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {changed && (
            <div className={'mc-flex-20 mc-p30 mc-b2t'}>
              <div className={'mc-grow'}></div>
              <MCButton
                primary
                light
                medium
                radius
                type='button'
                onClick={this.cancelChanges}
                label={LANG_CONST.buttons.cancel}
              />
              <MCButton
                primary
                dark
                radius
                medium
                type='submit'
                label={LANG_CONST.buttons.save_changes}
              />
            </div>
          )}
        </form>
      </div>
    );
  }
}

export default withRouter(AppSettings);
